import { Box, Flex } from '@mantine/core';
import { SmallSquareButton } from '../../../../components/small-square-button/small-square-button';
import { useProcessAnalysisStore } from '../../../../store/process-analysis-store/process-analysis-store';
import {
  setActivePanel,
  setAgentViewMode,
} from '../../../../store/process-analysis-store/process-analysis-store.actions';
import { skyLightest } from '../../../../styles/design-tokens';
import { Icon } from '../../../../ui-library/icon/icon';
import { Select } from '../../../../ui-library/select/select';

const VIEW_MODE_OPTIONS = [
  {
    label: 'Cycle Time',
    value: 'cycle_time',
    leftSection: <Icon name="schedule" size={16} />,
  },
  {
    label: 'Usage',
    value: 'usage',
    leftSection: <Icon name="bar_chart" size={16} />,
  },
];

export const FiltersHeader = () => {
  const agentViewMode = useProcessAnalysisStore((state) => state.agentViewMode);

  return (
    <Flex gap={8}>
      <Box style={{ flex: 1 }}>
        <Select
          size="sm"
          options={VIEW_MODE_OPTIONS}
          value={agentViewMode}
          onChange={(value) => setAgentViewMode(value as string)}
        />
      </Box>
      <SmallSquareButton
        onClick={() => setActivePanel(null)}
        iconName="arrow_back_ios"
        style={{ backgroundColor: skyLightest }}
      />
    </Flex>
  );
};
